<template>
  <div class="rootContainer">
    <searchBar class="searchBar" searchType="12" @search="onSearch"></searchBar>

    <div ref="topBarDom" class="top-bar-container">
      <filterMenu
        title="版式"
        displayName="name"
        v-model="direction"
        :filtersContent="directionFlags"
        @selectChanged="filterChanged"
      ></filterMenu>

      <div class="row-filter">
        <filterMenu
          title="分类"
          displayName="name"
          v-model="category"
          :filtersContent="categorys"
          :openShowMoreBtn="true"
          @selectChanged="filterChanged"
        ></filterMenu>
      </div>

      <div class="row-filter fixed-filter-container">
        <div>
          <filterMenu
            title="排序"
            displayName="name"
            v-model="sort"
            :filtersContent="sortFlags"
            @selectChanged="filterChanged"
          ></filterMenu>
        </div>

        <!-- <div class="fixedFilter">
          <filterMenu
            title="尺寸"
            :filtersContent="directionFlags"
            defaultActive="true"
            @selectChanged="onSelectedDirection"
          ></filterMenu>
        </div>-->

        <div class="fixedFilter">
          <filterMenu
            title="价格"
            displayName="name"
            v-model="price"
            :filtersContent="resourceLevelOptions"
            @selectChanged="filterChanged"
          ></filterMenu>
        </div>

        <div class="fixedFilter">
          <filterMenu
            title="授权"
            displayName="name"
            v-model="commerical"
            :filtersContent="commericalFlags"
            @selectChanged="filterChanged"
          ></filterMenu>
        </div>

        <styleMenu
          class="style-layout"
          v-model="currentStyle"
          :menuList="StyleArrayMsg"
          @selectChange="onStyleChange"
        ></styleMenu>
      </div>
    </div>

    <div
      class="content-container"
      ref="contentcontainer"
      @scroll="handleScroll"
    >
      <ul class="content-list">
        <li
          v-for="(item, index) in contentList"
          :key="index"
          :class="{
            horizontalScene: direction.type == 0,
            verticalScene: direction.type == 1,
          }"
        >
          <div
            @click="addToCanvas(item)"
            class="bg"
            :style="{
              background:
                'url(' +
                $handleAssetsUrl(item.thumbnailUrl) +
                ') center/cover no-repeat',
            }"
          >
            <div class="logo-container">
              <div v-show="item.isCommerical" class="commerical-logo"></div>
            </div>

            <!-- <div class="addbtn" @click="addToCanvas(item)" @click.stop>添加到画布</div> -->
            <!-- <div v-if="item.payType == 4" class="vip-logo"></div>
            <div
              v-if="
                (UserMsg.payForMaterial != 1 && item.payType == 1) ||
                item.payType == 2 ||
                item.payType == 3
              "
              class="price-style"
            >
              {{ "￥" + item.price }}
            </div> -->
            <payType-subscript
              :item="item"
              style="right: 4px; bottom: 4px"
            ></payType-subscript>
            <div class="favorites-bg" @click="favoriteItem(item)" @click.stop>
              <div
                class="favorites-state"
                :class="[
                  item && item.favorites ? 'already-favorites' : 'no-favorites',
                ]"
              ></div>
            </div>
          </div>
          <!-- <img :src="$handleAssetsUrl(item.thumbnailUrl)" /> -->
        </li>
      </ul>
      <div class="loading">
        <Loading
          :loading="loadingStatus == 1"
          v-show="loadingStatus == 1"
        ></Loading>
        <div v-show="loadingStatus == 2">没有更多内容了哦</div>
      </div>
    </div>

    <isEmptyResult
      v-if="loadingStatus == 2 && contentList.length == 0"
    ></isEmptyResult>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import searchBar from "../searchBar";
import styleMenu from "../dropDownMenu";
import filterMenu from "../filterMenu";
import isEmptyResult from "../isEmptyResult";
import baseContent from "./baseContent.vue";
import PayTypeSubscript from "@/components/common/materialPayTypeSubscript";
import Loading from "@/components/emodal/templateLib/loading";

export default {
  mixins: [baseContent],
  name: "musicContent",
  data() {
    return {
      type: 12,
      //条件筛选记录
      priceFlags: [
        { name: "全部", value: "" },
        { name: "免费", value: "&payType=0" },
        // { name: "付费", value: "&payType=1" },
        { name: "会员专属", value: "&payType=4" },
        { name: "企业会员专属", value: "&payType=6" },
      ],
    };
  },
  props: {},
  components: {
    searchBar,
    styleMenu,
    filterMenu,
    isEmptyResult,
    PayTypeSubscript,
    Loading,
  },
  methods: {
    async getCategorys() {
      let requestBody = {
        type: this.type,
        style: this.currentStyle.id,
        direction: this.direction.value,
      };
      let response = await this._getCategorys(requestBody);
      if (response) {
        this.categorys = [{ id: null, name: "全部" }].concat(response);
      }
    },

    getContentList: function () {
      this.loadingStatus = 1;
      let url =
        "/api/common/material?type=12&fPage=24&sOfPage=24&pIndex=" +
        this.pageIndex;
      if (this.category && this.category.id != null) {
        url += "&category=" + this.category.id;
      }
      // if (this.currentStyle) {
      //   url += "&style=" + this.currentStyle.id;
      // }
      if (this.sort) {
        url += this.sort.value;
      }
      if (this.direction) {
        url += "&direction=" + this.direction.value;
      }
      if (this.price) {
        url += this.price.value;
      }
      if (this.commerical) {
        url += this.commerical.value;
      }
      if (
        typeof this.keyWord != "undefined" &&
        this.keyWord != null &&
        this.keyWord != ""
      ) {
        url += "&keyword=" + this.keyWord;
      }
      this.setTrackingData(url);
      this.$http
        .get(url)
        .then((res) => {
          if (this.keyWord) {
            let order_methods = {
              "": "推荐",
              "&orderBy=2": "最新",
            };
            let choose_prices = {
              "": "全部",
              "&payType=0": "免费",
              "&payType=4": "会员专属",
              "&payType=6": "企业会员专属",
              "&payType=1": "付费",
            };
            sensors.track("classifySearchResult", {
              search_source: "编辑器素材弹窗",
              keyword: this.keyWord,
              has_result: !!(res.data.data && res.data.data.length),
              material_type: "场景",
              search_type: "素材搜索",
              search_result_num: res.data.data.length,
              keyword_type: this.trackingData.keyword_type || "手动输入",
              order_method: this.sort ? order_methods[this.sort.value] : "推荐",
              choose_price: this.price
                ? choose_prices[this.price.value]
                : "全部",
            });
          }
          //console.log("获取场景页：" + JSON.stringify(res.data));
          if (!this.contentList) {
            this.contentList = res.data.data;
          } else {
            for (var i = 0; i < res.data.data.length; i++) {
              this.contentList.push(res.data.data[i]);
            }
          }

          if (res.data.total <= this.contentList.length) {
            this.loadingStatus = 2;
          } else {
            this.loadingStatus = 0;
          }
        })
        .catch((res) => {
          //console.log("获取数据失败");
          this.loadingStatus = 0;
        });
    },

    favoriteItem: function (item) {
      let postBody = {
        type: 12,
        id: item.id,
      };
      if (item.favorites) {
        postBody.isCancel = 1;
      }
      item.sprite = item;
      this.trackCollectContent({ ...item, collect_content: "场景" }, postBody);
      this.$http.post("/api/user/favorites", postBody).then((res) => {
        if (res.data.code == 200) {
          this.showLikesToast(postBody.isCancel ? 'unlikes' : 'likes');
          //请求的返回值中没有带收藏信息
          //所以这里做一个本地的伪处理
          if (item.favorites) {
            item.favorites = null;
            this.$bus.emit("favorites.toggle", item, false); //通知右侧列表
          } else {
            item.favorites = true;
            this.$bus.emit("favorites.toggle", item, true);
          }
        }
      });
    },
    addToCanvas: function (scene) {
      this.$bus.emit('beforeAddToCanvas', {data: scene, type: 'scene'});
      this.trackSearchResultClick(scene);
      let url = "/api/common/material?type=12&id=" + scene.id;
      this.$http.get(url).then((res) => {
        if (res.data.code == 200) {
          let sceneData = JSON.parse(res.data.data[0].data);
          this.insertScene(sceneData, res.data.data[0]);
        }
      });
      this.$store.commit("close_TemplateMaterialLibDialogMsg");
    },
    insertScene: async function (sceneData, dataMsg) {
      if(!sceneData.resolution || !sceneData.resolution.width || !sceneData.resolution.height){
        sceneData.resolution = { width:1920, height:1080}
      }
      let scale = this.TOOL.clientWidth / sceneData.resolution.width;
      let sceneIndex = this.SelectScenes_Msg.index + 1;
      let scene = await this.TOOL.addScenes(null, {resourceId: dataMsg.id});
      this.TOOL.moveScenesTo(scene.id, sceneIndex);
      await this.TOOL.selectScenes(scene);
      await scene.toFromJson(sceneData, scale, true).then(() => {
        this.$bus.emit("timeline_update_totaltime", { data: "scenes" });
        this.$store.commit("rm_scenesVipSprites", {
          id: this.SelectScenes_Msg.id,
        });
        this.$bus.emit("judgeItemPayType_vue", {
          type: "scenes",
          id: this.SelectScenes_Msg.id,
          option: {
            resourceId: dataMsg.id,
            fileType: 24,
          },
          opHelper: {
            isSvip: false,
          },
          scenesId: this.SelectScenes_Msg.id,
        });
      });
    },
    handleScroll(e) {
      if (this.loadingStatus != 0) {
        return;
      }
      let scrollTop = e.target.scrollTop,
        scrollHeight = e.target.scrollHeight,
        contentHeight = this.$refs.contentcontainer.clientHeight;
      if (scrollTop >= scrollHeight - contentHeight - 5) {
        this.pageIndex++;
        this.getContentList();
      }
    },
  },
  watch: {},
  computed: {
    ...mapGetters([
      "StyleArrayMsg",
      "MaterialPane_Size",
      "TOOL",
      "SelectScenes_Msg",
      "WorksProjectId",
      "UserMsg",
    ]),
  },
  created() {
    this.direction = this.directionFlags[0];
    this.sort = this.sortFlags[0];
    this.price = this.priceFlags[0];
    this.commerical = this.commericalFlags[0];

    // this.setStyle(0);
    // this.refreshClassifys();
    // this.refreshContentList();
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.rootContainer {
  height: 100%;
  background-color: #fff;
  border: 0px solid black;
  margin: 0px;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.top-bar-container {
  background-color: #fff;
  min-height: 50px;
  margin: 8px 40px 20px 40px;
  padding: 0;
  flex-shrink: 0;
}

.fixed-filter-container {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  height: 20px;
  /* margin-top: 20px; */
}
.fixed-filter-container .fixedFilter {
  margin-left: 29px;
}

.fixed-filter-container /deep/ .list-container {
  margin-left: 10px;
}

.fixed-filter-container /deep/ .list li {
  padding: 0 10px;
}

.style-layout {
  margin-left: 39px;
  margin-top: 12px;
}

.content-container {
  width: 100%;
  overflow-y: auto;
  flex-grow: 1;
}
.content-list {
  padding-top: 22px;
  padding-left: 39px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  /* overflow-y: auto; */
  /* height: 550px; */
  width: 100%;
  flex-grow: 1;
}
.loading {
  height: 110px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #333333;
  //line-height: 110px;

  &>div{
    height:30px;
    line-height: 30px;
    align-self: start;
  }
}

.content-list li {
  background-color: #f0f0f8;
  border-radius: 6px;
  border: solid 1px #f0f0f8;
  box-sizing: border-box;
  overflow: hidden;
  transition: all 0.4s;
}

.horizontalScene {
  width: 224px;
  height: 126px;
  margin-right: 21px;
  margin-bottom: 17px;
}

.verticalScene {
  width: 162px;
  height: 270px;
  margin-right: 29px;
  margin-bottom: 40px;
}

.content-list li:hover {
  transform: scale(1.17);
}

.content-list li:hover .addbtn {
  opacity: 1;
}

.content-list li:hover .price-style {
  opacity: 0;
}

.content-list li:hover .logo-container {
  opacity: 0;
}

.content-list li:hover .favorites-bg {
  display: block;
  animation: favorites-fadein 0.4s;
}

.bg {
  position: relative;
  width: 100%;
  height: 100%;
}

.addbtn {
  position: absolute;
  display: block;
  width: 88px;
  height: 28px;
  background-color: #5778fb;
  border-radius: 13px;
  left: 4px;
  bottom: 4px;

  text-align: center;
  padding: 5px 0;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #ffffff;

  opacity: 0;
  transition: all 0.4s;
}

.price-style {
  position: absolute;
  bottom: 4px;
  right: 4px;
  /* width: 72px; */
  padding: 0 6px;
  height: 18px;
  color: #ffffff;
  font-size: 12px;
  background-image: linear-gradient(108deg, #fa2dfc 0%, #325eff 100%);
  border-radius: 4px;
  text-align: center;

  transition: all 0.4s;
}

.logo-container {
  position: absolute;

  right: 0;
  display: flex;
  justify-content: flex-end;

  transition: all 0.4s;
}

.commerical-logo {
  width: 20px;
  height: 24px;
  background-image: url(../../../../../static/svg/template-material-lib/common/commerical.svg);
  background-repeat: no-repeat;
  background-size: cover;
  margin-right: 5px;
}

.vip-logo {
  position: absolute;
  bottom: 4px;
  right: 4px;
  width: 64px;
  height: 24px;
  background-image: url(../../../../../static/svg/template-material-lib/common/vip-exclusive.svg);
  background-repeat: no-repeat;
  background-size: cover;
}

@keyframes favorites-fadein {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.7;
  }
}

.favorites-bg {
  display: none;
  position: absolute;
  width: 24px;
  height: 20px;
  background-color: #ffffff;
  border-radius: 6px;
  right: 4px;
  top: 4px;

  opacity: 0.7;
  /* transition: all 0.4s; */
}

.favorites-bg:hover {
  opacity: 1;
}

.favorites-state {
  width: 12px;
  height: 12px;
  margin-top: 4px;
  margin-left: 6px;
}

.already-favorites {
  background-image: url(../../../../../static/svg/template-material-lib/common/already-favorite.svg);
  background-repeat: no-repeat;
  background-size: cover;
}
.no-favorites {
  background-image: url(../../../../../static/svg/template-material-lib/common/no-favorite.svg);
  background-repeat: no-repeat;
  background-size: cover;
}

.payLogo {
  position: absolute;
  right: 0;
  bottom: 0;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/templateLib/contents/sceneContent.vue